import { Pipe, PipeTransform } from '@angular/core'
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'

@Pipe({
    name: 'bypassSecurityURL',
    standalone: false
})
export class BypassSecurityUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | null): SafeUrl | null {
    if (value) {
      return this.sanitizer.bypassSecurityTrustUrl(value)
    }
    return null
  }
}
